// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__1sScJ","title":"AfterImages45_title__3b4PE","images":"AfterImages45_images__qx_4R"};